import { Organization } from 'types/organization.type';
import { BaseActiveProducer } from 'helpers/ActiveUserProducer/BaseActiveProducer';
import { Link } from '@mui/material';
import * as React from 'react';
import { ReactFragment } from 'react';
import { SupportActiveProducer } from './SupportActiveProducer';
import {
    getAllLicencedAgentsAndParents,
    getOrganizationTreeByGrantors,
    getOrganizationTreeByRoot,
} from '../../services/organizations';

export class LumenUnderwriterActiveUserProducer extends SupportActiveProducer {
    //for the purposes of ActiveUserProducer, LumenAdmins and Underwriters are in essence a specialized SupportActiveProducer
    async fetchAvailableAgents() {
        const allProducers = await getAllLicencedAgentsAndParents();
        this.availableProducers = allProducers.filter((a) => !a.parentInactive);
    }
}
